import * as e from "react";
import { forwardRef as t } from "react";
const s = t(function(o, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8 8L16 16M16 8L8 16",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  s as CloseSmall
};
